import { CASH_BANK_REGISTER_REPORT_REQUEST, CASH_BANK_REGISTER_REPORT_SUCCESS, CASH_BANK_REGISTER_REPORT_FAILURE } from "../types";
  
  const initialState = {
    bankCashRegisterReport: {},
    loading: false,
    error: null,
  };
  
  const bankCashRegisterReport = (state = initialState, action) => {
    switch (action.type) {
      case CASH_BANK_REGISTER_REPORT_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        };
      }
      case CASH_BANK_REGISTER_REPORT_SUCCESS: {
        console.log("CASH_BANK_REGISTER_REPORT_SUCCESS Payload",action.payload);
        
        return {
          ...state,
          bankCashRegisterReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case CASH_BANK_REGISTER_REPORT_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        };
      }
      default:
        return state;
    }
  };
  
  export default bankCashRegisterReport;
  